import axios from "axios";
import { Deuda } from "../types/Deuda.tsx";

const getDeudaBySocioId = async (
  socio_id: string,
  getAccessTokenSilently: () => Promise<string>
): Promise<Deuda> => {
  try {
    const token = await getAccessTokenSilently();
    const response = await axios.get<Deuda>(
      `${process.env.REACT_APP_BACK_URL}/pagos-socios/deuda_socio/${socio_id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener la deuda del socio:", error);
    throw error;
  }
};

const deudaService = {
  getDeudaBySocioId,
};
export default deudaService;